class EmilyVreviews extends HTMLElement {}
if (!customElements.get('emily-vreviews')) customElements.define('emily-vreviews', EmilyVreviews);

document.querySelectorAll('.emily-vreviews__media').forEach((media) => {
  const play = media.querySelector('.emily-vreviews__play');
  if (!play) return;
  play.addEventListener('click', () => {
    const id = media.dataset.videoId;
    const provider = media.dataset.videoProvider;
    if (!id) return;
    media.classList.add('is-playing');
    if (provider === 'file') {
      const video = media.querySelector('video.emily-vreviews__poster');
      if (!video) return;
      video.controls = true;
      video.muted = false;
      video.play();
      return;
    }
    const src = provider === 'vimeo'
      ? `https://player.vimeo.com/video/${id}?autoplay=1`
      : `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
    const frame = document.createElement('iframe');
    frame.src = src;
    frame.title = 'Customer video';
    frame.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture';
    frame.allowFullscreen = true;
    frame.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0';
    media.appendChild(frame);
  });
});
